import { useMemo } from "react";

import { useElementSize } from "../utilities/useElementSize.ts";
import { DimensionsContext } from "./DimensionsContext";

export const DimensionsProvider = ({
  width,
  height,
  padding,
  children,
}: {
  width: number;
  height: number;
  padding: number;
  children: React.ReactNode;
}) => {
  const { size: viewportSize, elementRef: viewportRef, setElementRef: setViewportRef } = useElementSize();

  const usableWidth = useMemo(() => width - padding * 2, [padding, width]);
  const usableHeight = useMemo(() => height - padding * 2, [height, padding]);

  // Bounds for the scene to be dragged in.
  const positionOrigin = useMemo(() => ({ x: width / 2, y: height / 2 }), [width, height]);

  const moduleMapBounds = useMemo(
    () => ({
      minX: 100 - positionOrigin.x,
      minY: 100 - positionOrigin.y,
      maxX: width - 100 - positionOrigin.x,
      maxY: height - 100 - positionOrigin.y,
    }),
    [width, height, positionOrigin],
  );

  return (
    <DimensionsContext.Provider
      value={{
        width,
        height,
        usableWidth,
        usableHeight,
        padding,
        viewportSize,
        viewportRef,
        setViewportRef,
        positionOrigin,
        moduleMapBounds,
      }}
    >
      {children}
    </DimensionsContext.Provider>
  );
};
